import * as THREE from 'three';

// A shell of stars on a far sphere. Each star carries its own phase and size
// attribute so it twinkles at its own rhythm — a subtle life-of-the-sky effect
// that avoids all-stars-in-sync artifacts.

let material = null;

export function createStarfield({ count = 3500, radius = 400 } = {}) {
  const geometry = new THREE.BufferGeometry();
  const positions = new Float32Array(count * 3);
  const phases    = new Float32Array(count);
  const sizes     = new Float32Array(count);

  for (let i = 0; i < count; i++) {
    const v = new THREE.Vector3().randomDirection().multiplyScalar(radius);
    positions[i * 3 + 0] = v.x;
    positions[i * 3 + 1] = v.y;
    positions[i * 3 + 2] = v.z;
    phases[i] = Math.random() * Math.PI * 2;
    sizes[i]  = 0.7 + Math.random() * 0.8;
  }

  geometry.setAttribute('position',  new THREE.BufferAttribute(positions, 3));
  geometry.setAttribute('twinkle',   new THREE.BufferAttribute(phases, 1));
  geometry.setAttribute('starScale', new THREE.BufferAttribute(sizes, 1));

  material = new THREE.ShaderMaterial({
    uniforms: { uTime: { value: 0 } },
    vertexShader: /* glsl */`
      attribute float twinkle;
      attribute float starScale;
      uniform float uTime;
      varying float vBrightness;
      void main() {
        vec4 mv = modelViewMatrix * vec4(position, 1.0);
        gl_Position = projectionMatrix * mv;
        gl_PointSize = 1.4 * starScale;
        // 0.45 → 1.0 brightness range, rotating per star via its phase.
        vBrightness = 0.45 + 0.55 * (0.5 + 0.5 * sin(uTime * 1.3 + twinkle * 4.7));
      }
    `,
    fragmentShader: /* glsl */`
      varying float vBrightness;
      void main() {
        gl_FragColor = vec4(vec3(vBrightness), 1.0);
      }
    `,
    depthWrite: false,
  });

  return new THREE.Points(geometry, material);
}

export function updateStars(tSeconds) {
  if (material) material.uniforms.uTime.value = tSeconds;
}
